import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { setCustomerBaseModal, setCreateCustomerModal } from '../actions/modalActions'
import { setShouldInvoice, setInvoiceReference, showCustomerBase, hasAgeRequirement } from '../../actions/receiptActions'
import { toggleKeyboard } from '../../actions/layoutActions'
import { setMessageModal } from '../../actions/generalActions'
import { getTranslation } from '../../actions/dataActions'
import * as resource from '../../constants/Resources'
import Modal from 'react-modal'
import * as properties from '../../constants/Properties'
import CustomerBaseListItem from '../../components/CustomerBaseListItem'
import $ from 'jquery'
import * as general from '../../constants/General'

// Set the app element for react-modal (do this once, ideally in your app entry point)
if (typeof document !== 'undefined') {
    Modal.setAppElement('#root')
}

function CustomerBaseModal(props) {
    const [data, setData] = useState({ inputField: '', customers: [] });
    function cancelTap() {
        setData({ inputField: '', customers: [] });
        props.setCustomerBaseModal([], false, 'default');
    }

    function createTap() {
        props.setCreateCustomerModal(true, createCustomerModalCallback, null, null, null, 0);
    }

    function createCustomerModalCallback(customer) {
        if (customer) {
            processTouchTap(customer);
            return;
        }
        setData({ inputField: '', customers: [] });
    }

    function removeTap() {
        processTouchTap(null);
        props.setCustomerBaseModal([], false, 'default');
        props.setShouldInvoice(false);
        props.setInvoiceReference('');
    }

    function resetTap() {
        $('#search').val('');
        setData({ inputField: '', customers: [] });
    }

    function processTouchTap(customer) {
        const callback = props.customerBaseModal.callback;

        if (customer) {
            const customerAge = customer && customer.Age;
            let ageRequirementResult = props.hasAgeRequirement(customerAge);
            if (ageRequirementResult.hasAgeRequirement) {
                const baseMessage = props.getTranslation(resource.RECEIPT_ONE_OR_MORE_AGE_CONTROL);
                var message = baseMessage + " \n ";
                if ((customerAge === null || customerAge === 0)) {
                    message = `${message} ${props.getTranslation(resource.CUSTOMER_NO_DATE_OF_BIRTH)}`;
                } else if (ageRequirementResult.minimumAgeNotReached || ageRequirementResult.maximumAgeNotReached) {
                    message = `${message} ${props.getTranslation(resource.CUSTOMER_INVALID_AGE)} (${customerAge})`;
                }
                props.setMessageModal(true, message);
                return;
            }
        }

        let callbackParams = [customer];

        if (props.customerBaseModal.callbackparams !== undefined) {
            props.customerBaseModal.callbackparams.map(param => {
                callbackParams.push(param);
                return '';
            })
        }

        setData({ inputField: '', customers: [] });
        props.setCustomerBaseModal([], false, 'default');

        if (callback !== null) {
            callback.apply(this, callbackParams);
        }
    }

    function prepareData(description, newCustomers) {
        const wrappedCustomers = Array.isArray(newCustomers)
            ? newCustomers.map(c => (c.Customer ? c : { Customer: c }))
            : [];
        setData({ inputField: description, customers: wrappedCustomers });
    }

    function updateInputFieldAfterSearch(input) {
        let labelList = props.customerBaseModal.listvalues;
        if (typeof labelList === 'string') {
            labelList = labelList
                .split(',')
                .map(s => parseInt(s, 10))
                .filter(n => !isNaN(n));
        }

        fetch(general.API_URL_GET_CUSTOMERS, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                Description: input,
                LabelIDs: labelList
            })
        })
            .then(result => result.json())
            .then(customers => prepareData(input, customers));
    }

    function showKeyboard() {
        const searchTerm = props.getTranslation(resource.SEARCH_TERM);
        props.toggleKeyboard(true, '#search', searchTerm, updateInputFieldAfterSearch, null, false);
    }

 
    useEffect(() => {
        if (props.customerBaseModal.show === true) {
            let labelList = props.customerBaseModal.listvalues;
            if (typeof labelList === 'string') {
                labelList = labelList
                    .split(',')
                    .map(s => parseInt(s, 10))
                    .filter(n => !isNaN(n));
            }
            // If labelList is empty or not present, show keyboard. Otherwise, fetch customers immediately.
            if (!labelList || (Array.isArray(labelList) && labelList.length === 0)) {
                showKeyboard();
            } else {
                updateInputFieldAfterSearch('');
            }
        }
    }, [props.customerBaseModal.show]);


    return (
        <Modal className='customerBaseModal'
            contentLabel=""
            isOpen={props.customerBaseModal.show}
            style={properties.customerBaseModalStyle}
        >
            <div className="customerBaseModal_header">
                <div className="header_top">
                    {props.getTranslation(resource.CUSTOMER_LIST)}
                </div>
            </div>
            <div className="customerBaseModal_content">
                <div>
                    <div className="search_bar_div">
                        <input
                            id="search"
                            className="search_bar"
                            placeholder={props.getTranslation(resource.SEARCH_TERM)}
                            onClick={showKeyboard}
                            readOnly="readOnly"
                            value={data.inputField}
                        />
                        {data.inputField !== '' &&
                            <button className="btnReset" onClick={resetTap} >
                                {props.getTranslation(resource.RESET)}
                            </button>
                        }
                    </div>
                    <div className="customerList" >
                        {
                            data.customers.slice(0, 500)
                                .sort((a, b) => { if (!a.Customer || !b.Customer) return 0; if (!a.Customer.Name) return 1; if (!b.Customer.Name) return -1; return a.Customer.Name.localeCompare(b.Customer.Name); })
                                .map(val =>
                                    val.Customer ? (
                                        <CustomerBaseListItem
                                            key={val.Customer.CustomerId}
                                            Customer={val.Customer}
                                            Callback={processTouchTap}
                                        />
                                    ) : null
                                )
                        }
                    </div>
                </div>
            </div>
            <div className="customerBaseModal_footer">
                <button className="btnCancel" onClick={cancelTap} >
                    {props.getTranslation(resource.CANCEL)}
                </button>
                <button className="btnCreate" onClick={createTap} >
                    {props.getTranslation(resource.NEW)}
                </button>
                <button className="btnRemove" onClick={removeTap} >
                    {props.getTranslation(resource.NO_CUSTOMER)}
                </button>
            </div>
        </Modal>
    )
}

function mapStateToProps(state) {
    return {
        customerBaseModal: state.modalState.customerBaseModal,
        keyboard: state.layoutState.keyboard
    }
}

export default connect(mapStateToProps, {
    setCustomerBaseModal,
    toggleKeyboard,
    setShouldInvoice,
    setInvoiceReference,
    setCreateCustomerModal,
    showCustomerBase,
    hasAgeRequirement,
    setMessageModal,
    getTranslation
})(CustomerBaseModal)


// WEBPACK FOOTER //
// src/modal/components/CustomerBaseModal.jsx